import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Icons, IconType } from '../../../../constants/icons';
import {
  RewardRedemptionState,
  RewardRedemptionType,
  RewardReferralRole,
} from '../../../../models/RewardStore';
import { WebBoosterType } from '../../../../models/UserStore';
import { LoadingSpinner } from '../../../Molecules';

import styles from './WebStoreProductRedemptionTemplate.module.css';

export type WebStoreProductRedemptionTemplateProps = {
  state: RewardRedemptionState;
  rewardType: RewardRedemptionType | undefined;
  referralRole: RewardReferralRole;
  productName: string | undefined;
  webBoosterType: WebBoosterType | undefined;
  onClickProduct: () => void;
  onClickWebStore: () => void;
};

const referralDetails = {
  [RewardReferralRole.Customer]: {
    title: 'Purchase Successful',
    description: 'Access Product, start refer user from store.',
  },
  [RewardReferralRole.Distributor]: {
    title: 'Application Successful',
    description: 'Access Role, start refer user from store.',
  },
  [RewardReferralRole.Partner]: {
    title: 'Application Successful',
    description: 'Access Role, start refer user.',
  },
};

export const WebStoreProductRedemptionTemplate = memo(
  ({
    state,
    rewardType,
    referralRole,
    productName,
    webBoosterType,
    onClickProduct,
    onClickWebStore,
  }: WebStoreProductRedemptionTemplateProps) => {
    const { t } = useTranslation();
    const referralDetail = referralDetails[referralRole];

    return (
      <div className={styles.webStoreRedemption}>
        {state === RewardRedemptionState.Failed ? (
          <div className={styles.fail}>
            <img src={Icons[IconType.Cross]} className={styles.icon} />
            <div className={styles.title}>{t('Fail')}</div>
          </div>
        ) : state === RewardRedemptionState.Fulfilled ? (
          <div className={styles.success}>
            <img src={Icons[IconType.Tick]} className={styles.icon} />
            <div className={styles.title}>{t(referralDetail.title)}</div>
            {rewardType === RewardRedemptionType.Token ? (
              <div className={styles.subTitle}>
                {t('Start creating Memory Practice on JOYAJOY now!')}
              </div>
            ) : rewardType === RewardRedemptionType.Bread ? (
              <div className={styles.subTitle}>
                {t(
                  'You have successfully purchased some bread. Consider donating them to those in need!',
                )}
              </div>
            ) : (
              <>
                <div className={styles.subTitle}>
                  {t('Start using JOYAJOY now!')}
                </div>
                <div className={styles.description}>
                  {rewardType === RewardRedemptionType.WebPlan ? (
                    webBoosterType === WebBoosterType.Bible ? (
                      <Trans i18nKey={'Access JOYAJOY Bible Memory Booster.'}>
                        Access
                        <span
                          className={styles.boldText}
                          onClick={onClickProduct}
                        >
                          JOYAJOY Bible Memory Booster
                        </span>
                        .
                      </Trans>
                    ) : (
                      <Trans i18nKey={'Access JOYAJOY Exam & Memory Booster.'}>
                        Access
                        <span
                          className={styles.boldText}
                          onClick={onClickProduct}
                        >
                          JOYAJOY Exam & Memory Booster
                        </span>
                        .
                      </Trans>
                    )
                  ) : (
                    <Trans
                      i18nKey={referralDetail.description}
                      values={{
                        ProductName: productName,
                      }}
                    >
                      Access
                      <span
                        className={styles.boldText}
                        onClick={onClickProduct}
                      >
                        My Referral Role
                      </span>
                      , and start referring new users from
                      <span
                        className={styles.boldText}
                        onClick={onClickWebStore}
                      >
                        Web Store
                      </span>
                      .
                    </Trans>
                  )}
                </div>
              </>
            )}
            <button className={styles.OkButton} onClick={onClickProduct}>
              {t('OK')}
            </button>
          </div>
        ) : (
          <LoadingSpinner loading={true} />
        )}
      </div>
    );
  },
);
